import { render, staticRenderFns } from "./LicenseBinding.vue?vue&type=template&id=680f3002&scoped=true&lang=pug"
import script from "./LicenseBinding.vue?vue&type=script&lang=js"
export * from "./LicenseBinding.vue?vue&type=script&lang=js"
import style0 from "./LicenseBinding.vue?vue&type=style&index=0&id=680f3002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f3002",
  null
  
)

export default component.exports